import { render, staticRenderFns } from "./radioDialog.vue?vue&type=template&id=2c1971fc&scoped=true"
import script from "./radioDialog.vue?vue&type=script&lang=js"
export * from "./radioDialog.vue?vue&type=script&lang=js"
import style0 from "./radioDialog.vue?vue&type=style&index=0&id=2c1971fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1971fc",
  null
  
)

export default component.exports